import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { Permissions } from '@/types';
import { useHavePermission } from '@/hooks';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import {
  TemplateTypeEnum,
  useAllAssemblyTemplatesForFilterSideBarQuery,
} from '@/__generated__/graphql';

export const useGetAssemblyTemplates = () => {
  const structureId = useGetStructureId();
  const canReadDefects = useHavePermission(Permissions.READ_DEFECTS);

  const setTemplateId = useSetAtom(state.selectedAssemblyTemplateId)!;
  const setAssemblyTemplate = useSetAtom(state.assemblyTemplate);
  const setAllAssemblyTemplates = useSetAtom(state.allAssemblyTemplates);

  const { data: templatesData } = useAllAssemblyTemplatesForFilterSideBarQuery({
    variables: {
      structureId,
      type: TemplateTypeEnum.Assembly,
    },
    skip: !structureId,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    const assemblyTemplates = templatesData?.allTemplates;
    if (assemblyTemplates) {
      setAllAssemblyTemplates(templatesData.allTemplates);
      let selectedTemplate = assemblyTemplates[0];
      if (!selectedTemplate) return;
      if (!canReadDefects) {
        selectedTemplate = {
          ...selectedTemplate,
          fields:
            selectedTemplate?.fields?.filter(
              (templateField) =>
                !templateField.permission || templateField.permission !== Permissions.READ_DEFECTS
            ) || [],
        };
      }
      setTemplateId(selectedTemplate.id);
      setAssemblyTemplate(selectedTemplate);
    }
  }, [
    templatesData?.allTemplates,
    setAssemblyTemplate,
    setTemplateId,
    setAllAssemblyTemplates,
    canReadDefects,
  ]);
};
